import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { getConfiguration } from '@ms/items-view/lib/private/models/configuration/getConfiguration';
import { ISpfxAdapter, IListViewSpfxHostApplication } from '@ms/odsp-datasources/lib/interfaces/clientSideExtensions/ISpfxAdapter';
import { spClientSideFrameworkConfigurationFacet } from '../../dataSource/Facets';
import { ISPFrameworkClientInfo } from '@ms/odsp-datasources/lib/interfaces/clientSideExtensions/IClientSideExtensions';

/**
 * Facet for field customizer information, used for debug client-side extension
 */
export interface ICustomizedFieldsDict {
  [fieldKey: string]: string | {
    id?: string;
    properties?: string | object
  };
}

export interface ICustomActionExtensionDict {
  [key: string]: {
      properties?: {},
      location: string
  };
}

export function getLoadSpfxAdapterFunction(itemCache: IItemCache):
  ((SPFXClientInfo?: ISPFrameworkClientInfo ) => Promise<ISpfxAdapter>) | undefined {
    const {
      spClientSideFrameworkConfiguration
    } = getConfiguration(itemCache, {
      spClientSideFrameworkConfiguration: spClientSideFrameworkConfigurationFacet
    });

    return spClientSideFrameworkConfiguration && spClientSideFrameworkConfiguration.loadSpfxAdapter || undefined;
}

export function getLoadSpfxHostApplicationFunction(itemCache: IItemCache):
  ((SPFXClientInfo?: ISPFrameworkClientInfo ) => Promise<IListViewSpfxHostApplication>) | undefined {
    const {
      spClientSideFrameworkConfiguration
    } = getConfiguration(itemCache, {
      spClientSideFrameworkConfiguration: spClientSideFrameworkConfigurationFacet
    });

    return spClientSideFrameworkConfiguration && spClientSideFrameworkConfiguration.loadSpfxHostApplication || undefined;
}